import React from 'react';
import { PoolDetail } from "../../entities/LinearStaking";
import PoolCard from "../PoolCard";

interface Props {
    pools: PoolDetail[];
    onOpenDetail: (pool: PoolDetail) => void;
}

const PoolGrid: React.FC<Props> = ({ pools, onOpenDetail }) => {
    return (
        <div className="w-full flex justify-center items-center py-8 grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-8">
            {pools.map((pool, idx) => (
                <PoolCard
                    key={idx}
                    pool={pool}
                    onOpenDetail={() => onOpenDetail(pool)}
                />
            ))}
        </div>

    );
};

export default PoolGrid;
